// import React, { useState, useEffect } from "react";
// import "./JobBoard.css";

// const JobBoard = ({ jobs = [] }) => {
//   console.log("template2 jobs", jobs);

  
//   const formatDate = (dateString) => {
//     if (!dateString) return "No Date Available";
  
//     const date = new Date(dateString);
//     if (isNaN(date)) return dateString;
  
//     return date.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };
  

//   // Ensure jobs is an array and map it safely
//   const mappedJobs = jobs.length > 0 ? jobs.map((job) => {
//     if (!Array.isArray(job)) return null; // Prevent errors if job isn't an array

//     const jobId = job.find((item) => item.label === "Job ID")?.id ?? "No Job ID";
//     const jobTitle = job.find((item) => item.label === "Job Title")?.Job_Title ?? "No Job Title";
//     const jobLocation = job.find((item) => item.label === "City")?.City ?? "No Location";
//     const jobMinExperience = job.find((item) => item.label === "Minimum Experience")?.Minimum_Experience ?? "N/A";
//     const jobMaxExperience = job.find((item) => item.label === "Maximum Experience")?.Maximum_Experience ?? "N/A";
//     const jobCreatedRaw = job.find((item) => item.label === "Created At")?.created_at ?? "N/A";
//     const jobCountry = job.find((item) => item.label === "Country")?.Country ?? "No Country";
//     const jobType = job.find((item) => item.label === "Job Type")?.Job_Type ?? "Full Time";
//     const jobDescription = job.find((item) => item.label === "Job Description")?.Job_Description ?? "No Description";
//   const jobCreated = formatDate(jobCreatedRaw)

//     return {
//       id: jobId,
//       title: jobTitle,
//       location: `${jobCountry}, ${jobLocation}`,
//       experience: `${jobMinExperience} to ${jobMaxExperience} Years`,
//       jobType,
//       posted: jobCreated,
//       description: jobDescription,
//     };
//   }).filter(job => job !== null) : [];

//   // State for selected job
//   const [selectedJob, setSelectedJob] = useState(mappedJobs.length > 0 ? mappedJobs[0] : null);

//   // Update selectedJob when jobs change
//   useEffect(() => {
//     if (mappedJobs.length > 0) {
//       setSelectedJob(mappedJobs[0]);
//     } else {
//       setSelectedJob(null);
//     }
//   }, [jobs]);

//   return (
//     <div className="job-board-container">
//       {/* Left Side - Job List */}
//       <div className="job-list">
//         {mappedJobs.length > 0 ? (
//           mappedJobs.map((job) => (
//             <div
//               key={job.id}
//               className={`job-item ${selectedJob && selectedJob.id === job.id ? "active" : ""}`}
//               onClick={() => setSelectedJob(job)}
//             >
//               <h3>{job.title}</h3>
//               <p> {job.experience} | {job.location}</p>
//               <span>{job.posted}</span>
//             </div>
//           ))
//         ) : (
//           <p>No jobs available</p>
//         )}
//       </div>

//       {/* Right Side - Job Details */}
//       <div className="job-details">
//         {selectedJob ? (
//           <>
//             <h2>{selectedJob.title}</h2>
//             <p><strong>Location:</strong> {selectedJob.location}</p>
//             <p><strong>Experience:</strong> {selectedJob.experience}</p>
//             <p><strong>Job Type:</strong> {selectedJob.jobType}</p>
//             <p><strong>Posted:</strong> {selectedJob.posted}</p>
//             <h3>Overview:</h3>
//             <p dangerouslySetInnerHTML={{ __html: selectedJob.description }}></p>
//             <button className="apply-button">Apply</button>
//           </>
//         ) : (
//           <p>Select a job to see details</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default JobBoard;

















import React, { useState, useEffect } from "react";
import "./JobBoard.css";
import JobDetails from "../JobDetails/JobDetails";
import { BaseUrl } from "../UserData";
import { fetchStyle } from "../Config/config";
import styled from "styled-components";


const JobBoard = ({ jobs = [], renderHTML }) => {
  const [theme, setTheme] = useState({});
  const styleUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=syra`;
      useEffect(() => {
          const fetchThemes = async () => {
              const fetchedTheme = await fetchStyle(styleUrl);
              console.log("Fetched Theme:", fetchedTheme);
              setTheme(fetchedTheme);
          };
          fetchThemes();
      }, []);

      const ThemeWrapper = styled.div`
        background-color: ${theme.bg_color};
        
        /* Define global CSS variables */
        --text-color: ${theme.text_color || "#333"};
        --text-font: ${theme.text_font || "Arial, sans-serif"};
       
        --button-bg: ${theme.button_color || "#0073e6"};
        --button-hover-bg: ${theme.button_hover_color || "#005bb5"};
    --bg-color:${theme.bg_color || "#ffffff"};
        font-family: var(--text-font);
        color: var(--text-color);
        background-color: var(--bg-color);
    `;

 
  console.log("template2 jobs", jobs);

  const formatDate = (dateString) => {
    if (!dateString) return "No Date Available";
    const date = new Date(dateString);
    return isNaN(date)
      ? dateString
      : date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
  };

  

  const [selectedJob, setSelectedJob] = useState(jobs.length > 0 ? jobs[0] : null);

  useEffect(() => {
    if (jobs.length > 0) {
      setSelectedJob(jobs[0]);
    } else {
      setSelectedJob(null);
    }
  }, [jobs]);

  const handleScrollAndJobDetail = (job)=>{
    setSelectedJob(job)
    console.log(job)
    window.scrollTo({top:0, behavior:"smooth"})
  }

  return (
    // <div className="job-board-container">
    //   <div className="job-list">
    //     {jobs.length > 0 ? (
    //       jobs.map((job) => (
    //         <div
    //           key={job.job_id}
    //           className={`job-item ${selectedJob && selectedJob.job_id === job.job_id ? "active" : ""}`}
    //           onClick={() => handleScrollAndJobDetail(job)}
              
    //         >
    //           <h3>{job.job_title}</h3>
    //           <p>1 | {job.job_country}</p>
    //           <span>{job.created_at}</span>
    //         </div>
    //       ))
    //     ) : (
    //       <p>No jobs available</p>
    //     )}
    //   </div>

    //   <div>
    //     {selectedJob ? (
    //       <JobDetails
    //         jobDetails={selectedJob?.job_id}
    //         renderHTML={renderHTML}
    //       />
    //     ) : (
    //       <p>Select a job to see details</p>
    //     )}
    //   </div>
    // </div>

    <div className="jb-job-board-container">
  {/* Job List (30%) */}
  <div className="jb-job-list">
    {jobs.length > 0 ? (
      jobs.map((job) => (
        <ThemeWrapper
          key={job.job_id}
          className={`jb-job-item ${selectedJob && selectedJob.job_id === job.job_id ? "active" : ""}`}
          onClick={() => handleScrollAndJobDetail(job)}
        >
          <h3>{job.job_title}</h3>
          <p>1 | {job.job_country}</p>
          <span>{job.created_at}</span>
        </ThemeWrapper>
      ))
    ) : (
      <p>No jobs available</p>
    )}
  </div>

  {/* Job Details (70%) */}
  <div className="jb-job-details">
    {selectedJob ? (
      <JobDetails jobDetails={selectedJob?.job_id} renderHTML={renderHTML} />
    ) : (
      <p>Select a job to see details</p>
    )}
  </div>
</div>

  );
};

export default JobBoard;

























